import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const MetaDeliveryPage = lazy(
  () => import('~/features/content-enrichment/pages/meta-delivery-page'),
);

/** Step 5 — Delivery page for the Meta Ads enrichment funnel. Polls the job
 *  status endpoint until the DELIVERY stage completes, then redirects to
 *  the catalog-operations batch detail. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/delivery',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <MetaDeliveryPage />
    </Suspense>
  ),
});
